// components/CustomDivider.js
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";

// Define the type for your custom prop
interface CustomDividerProps {
  isVertical?: boolean;
}

const CustomDivider = styled(Divider, {
  // Use shouldForwardProp to prevent 'isVertical' from being passed to the DOM element
  shouldForwardProp: (prop) => prop !== "isVertical",
})<CustomDividerProps>(({ theme, isVertical }) => ({
  margin: isVertical ? theme.spacing(0, 1) : theme.spacing(2, 0),
  border: "1px solid #DBDADE",
  ...(isVertical && {
    height: "100%",
    width: "1px",
  }),
  ...(!isVertical && {
    width: "100%",
    height: "1px",
  }),
}));

export default CustomDivider;
